import { BaseRemoteService } from "@ofqual/portal-core/core/dataAccess";
import {
  Opts,
  PagedResponse,
  QueryParams,
} from "@ofqual/portal-core/core/types";
import { paramsToSearchString } from "@ofqual/portal-core/core/utils/urlHelper";
import { OfqualNotification } from "../domain/OfqualNotification";

const DEFAULT_PAGE_SIZE = 10;
export class NotificationsService extends BaseRemoteService {
  public async getMy(
    params: QueryParams,
    opts: Opts
  ): Promise<PagedResponse<OfqualNotification>> {
    const url = `${this.apiRoot}/notifications/my/${paramsToSearchString({
      ...params,
      pageSize: DEFAULT_PAGE_SIZE,
    })}`;
    const response = await super.getRequest<PagedResponse<OfqualNotification>>(
      url,
      opts
    );
    return response;
  }

  public async readNotification(id: string, opts: Opts) {
    const url = `${this.apiRoot}/notifications/${id}/read`;
    await super.postRequest(url, null, opts);
  }

  public async bulkReadNotifications(ids: string[], opts: Opts) {
    const url = `${this.apiRoot}/notifications/bulk_read`;
    await super.postRequest(url, ids, opts);
  }
}
